import i18n from '@/config/i18n'

const getAppTitle = (): string =>
  String(i18n.global.t('navigation.navbar.appTitle'))

const withAppTitle = (pageTitle?: string): string => {
  const appTitle = getAppTitle()

  return pageTitle ? `${pageTitle} | ${appTitle}` : appTitle
}

export { getAppTitle, withAppTitle }
